import { useCallback, useRef, useState } from 'react';
import { Tooltip } from 'modules/Tooltip';
import { Container } from './styled';
const isTruncated = (element) => element !== null && element.offsetWidth < element.scrollWidth;
export function TableCellText(props) {
    const { primary = '', secondary = '', dense } = props;
    const primaryRef = useRef(null);
    const secondaryRef = useRef(null);
    const [displayTooltip, setDisplayTooltip] = useState(false);
    const measureTruncation = useCallback(() => {
        setDisplayTooltip(isTruncated(primaryRef.current) || isTruncated(secondaryRef.current));
    }, []);
    return (<Tooltip title={`${primary} ${secondary}`} disabled={!displayTooltip} width={256}>
      <Container $dense={dense} onMouseEnter={measureTruncation} onFocus={measureTruncation}>
        {primary && (<span className="tct-text tct-primary" ref={primaryRef}>
            {primary}
          </span>)}

        {secondary && (<span className="tct-text tct-secondary" ref={secondaryRef}>
            {secondary}
          </span>)}
      </Container>
    </Tooltip>);
}
